import script from "./RevShareAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./RevShareAdmin.vue?vue&type=script&setup=true&lang=js"

import "./RevShareAdmin.vue?vue&type=style&index=0&id=bb887856&lang=scss&scoped=true"
import "./RevShareAdmin.vue?vue&type=style&index=1&id=bb887856&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb887856"]])

export default __exports__